import { act } from "react";
import { 
  ENRICH_LIST_REQUEST, 
  ENRICH_LIST_SUCCESS, 
  ENRICH_LIST_FAIL, 
  ENRICH_CONTACTS_REQUEST, 
  ENRICH_CONTACTS_SUCCESS, 
  ENRICH_CONTACTS_FAIL,
  ENRICH_ORGANIZATIONS_SUCCESS,
  ENRICH_ORGANIZATIONS_FAIL
} from "../../constants/enrichConstants";

const initialValues = {
  contacts: {
    previous: null,
    next: null,
    count: 0,
    results: [],
  },
  organizations: [],
  loading: false,
  enrichLoading: false,
  error: null
}

export const EnrichActionReducer = (
  state = initialValues,
  action
) => {
  switch (action.type) {
    case ENRICH_LIST_REQUEST:
      return { ...state, loading: true };
      
    case ENRICH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        contacts: action.payload,
        organizations: action.payload.organizations
      };
      
    case ENRICH_LIST_FAIL:
      return { 
        ...state, 
        loading: false,
        error: action.payload 
      };

    case ENRICH_CONTACTS_REQUEST:
      return { ...state, enrichLoading: true };
      
    case ENRICH_CONTACTS_SUCCESS:
      return {
        ...state,
        enrichLoading: false,
        error: null
      };
      
    case ENRICH_CONTACTS_FAIL:
      return { 
        ...state, 
        enrichLoading: false,
        error: action.payload 
      };
      
    case ENRICH_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.payload
      };
      
    case ENRICH_ORGANIZATIONS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    default:
      return state;
  }
}; 